'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initializer = initializer;
exports.finalizer = finalizer;
exports.createComponent = createComponent;

var _components = require('linksoft/core/components');

var _components2 = _interopRequireDefault(_components);

var _store = require('linksoft/core/store');

var _store2 = _interopRequireDefault(_store);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('debug')('linksoft-react');

// initializer
function initializer() {
    (0, _jquery2.default)("[data-component]", this).each(function (i, element) {
        var name = (0, _jquery2.default)(element).attr('data-component');
        var plainProps = (0, _jquery2.default)(element).attr('data-component-props') || (0, _jquery2.default)(element).attr('data-component-args') || "{}";
        var props = JSON.parse(plainProps);

        log('creating component \'' + name + '\' with props: ' + plainProps);
        createComponent(name, element, props);
        log('component \'' + name + '\' created');
    });
}

// should be called before any ajax request replaces old DOM element(s)
function finalizer() {
    (0, _jquery2.default)("[data-component]", this).each(function (i, element) {
        log('try unmount component from element: %o', element);
        if ((0, _reactDom.unmountComponentAtNode)(element)) {
            log('component unmounted from element: %o', element);
        }
        log('unmount failed. component not found in element: %o', element);
    });
}

function createComponent(name, element, props) {
    var Component = _components2.default.get()[name];
    if ((0, _isObject2.default)(Component)) {
        (0, _reactDom.render)(_react2.default.createElement(
            _reactRedux.Provider,
            { store: _store2.default.get() },
            _react2.default.createElement(Component, props)
        ), element);
    }
}

exports.default = {
    initializer: initializer,
    finalizer: finalizer,
    createComponent: createComponent
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-react/index.js
// module id = 418
// module chunks = 0 1